export default {
  state: {
    settings: {},
    questions: [],
  },
  mutations: {
    setTestSettings(state, payload) {
      state.settings = payload
    },
    setTestQuestions(state, payload) {
      state.questions = payload
    },
  },
  actions: {
    queryTestQuestions({dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'tests/settings')
        .then(res => {
          commit('setTestSettings', res.data)
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'tests/questions')
        .then(res => {
          commit('setTestQuestions', res.data)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    storeTestQuestion({dispatch}, formData) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'tests/questions', formData)
        .then(res => {
          dispatch('queryTestQuestions')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    updateTestQuestion({dispatch}, payload) {
      dispatch('setPreloader', true)
      axios.patch(process.env.VUE_APP_API_ENDPOINT + 'tests/questions/' + payload[0], payload[1])
        .then(res => {
          dispatch('queryTestQuestions')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    sortableTestQuestion({commit, state, dispatch}, payload) { // oldIndex, newIndex
      state.questions.splice(payload[1], 0, state.questions.splice(payload[0], 1)[0])
      commit('setTestQuestions', state.questions)
      let sort_ids = []
      for (let i = 0; i < state.questions.length; i++) {
        sort_ids.push(state.questions[i].id)
      }

      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'tests/questions/sort', {sort: sort_ids})
        .then(res => {
          dispatch('queryTestQuestions')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    deleteTestQuestion({commit, dispatch, state}, payload) {
      dispatch('setPreloader', true)
      axios.delete(process.env.VUE_APP_API_ENDPOINT + 'tests/questions/' + payload)
        .then(res => {
          dispatch('queryTestQuestions')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    updateTestSettings({dispatch}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'tests/settings', payload)
        .then(res => {
          dispatch('queryTestQuestions')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    deleteTestAnswer({commit, dispatch, state}, payload) {
      dispatch('setPreloader', true)
      axios.delete(process.env.VUE_APP_API_ENDPOINT + 'tests/questions/answer/' + payload.id)
        .then(res => {
          dispatch('queryTestQuestions')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
  },
  getters: {
    getTestSettings: state => {
      return state.settings
    },
    getTestQuestions: state => {
      return state.questions
    },
  }
}